export const NewDealBadge = () => (
  <span className='font-poppins rounded bg-primary-off px-1.5 py-0.5 text-[11px] font-semibold text-[#ECECF2]'>
    New!
  </span>
);
